(() => {
  const unlockThumbArrows = (root) => {
    root
      .querySelectorAll(
        "slider-component.thumbnail-slider .slider-button[disabled]"
      )
      .forEach((b) => b.removeAttribute("disabled"));
  };

  const getThumbButtons = (gallery) =>
    Array.from(gallery.querySelectorAll("button.thumbnail"));

  const getCurrentIndex = (thumbs, gallery) => {
    const current =
      gallery.querySelector('button.thumbnail[aria-current="true"]') ||
      thumbs[0];
    return Math.max(0, thumbs.indexOf(current));
  };

  // 初期化（動的にsectionが差し替わっても耐える）
  const init = () => {
    document.querySelectorAll("media-gallery").forEach((gallery) => {
      // disabled 解除（初回）
      unlockThumbArrows(gallery);

      // disabled が付け直されても解除する（重要）
      const obs = new MutationObserver(() => unlockThumbArrows(gallery));
      obs.observe(gallery, {
        attributes: true,
        subtree: true,
        attributeFilter: ["disabled"],
      });

      // クリックでメイン画像切替（サムネ矢印）
      gallery.addEventListener("click", (e) => {
        const btn = e.target.closest(
          "slider-component.thumbnail-slider .slider-button"
        );
        if (!btn) return;

        // 念のため都度解除（Safariなどで保険）
        btn.removeAttribute("disabled");

        const thumbs = getThumbButtons(gallery);
        if (thumbs.length <= 1) return;

        const idx = getCurrentIndex(thumbs, gallery);
        const isNext = btn.classList.contains("slider-button--next");

        // ★ここが「ループ」：最後→最初 / 最初→最後
        const nextIdx = isNext
          ? (idx + 1) % thumbs.length
          : (idx - 1 + thumbs.length) % thumbs.length;

        thumbs[nextIdx].click();
        thumbs[nextIdx].scrollIntoView({ block: "nearest", inline: "center" });
      });
    });
  };

  document.addEventListener("DOMContentLoaded", init);

  // 商品切替（variant）等でDOM差し替えが起きても再適用
  document.addEventListener("shopify:section:load", init);
})();
